module.exports = __webpack_public_path__ + "img/KUCE_07.7ea60433.png";